import { createContext } from 'react';

/**
 * The drawer's form template reads (`createTemplateRequests`). The summary renderers receive only
 * `{ change, row, detail }`, and an override row's entity is the override, not the form.
 */
export const FormTemplateRequestsContext = createContext(null);
